import { render, staticRenderFns } from "./crearConceptoDigitacion.vue?vue&type=template&id=2102ffa6"
import script from "./crearConceptoDigitacion.vue?vue&type=script&lang=js"
export * from "./crearConceptoDigitacion.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports